import { Box } from '@mui/system';
import { StyledBagelcodeBundle } from './style';
import { BundleProps } from 'utils/types';
import BundlePrice from '../BundlePrice';
import {
  EBadgePosition,
  EBadgeType,
  EBundlesInternalViewModel,
  EProductType,
} from 'utils/enums';
import { RibbonBadge } from 'components/Badge/RibbonBadge/RibbonBadge';
import { useEffect, useState } from 'react';
import { BadgeData } from 'components/Badge/types';
import { BagelcodeSaleBadge } from 'components/Badge/Sale/BagelcodeSaleBadge';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

export const BagelcodeBundle: React.FC<BundleProps> = ({
  price,
  productList,
  badges = [],
  backgroundSrc,
  backgroundColor = { colorOne: '#880000' },
  salePercentage = 0,
  salePercentageDisplayType,
  borderRadius,
}) => {
  const [ribbonBadge, setRibbonBadge] = useState<any>(null);

  useEffect(() => {
    let foundRibbon;
    if (badges.length > 0) {
      if (badges[0].badge) {
        foundRibbon = badges?.find(
          (badge: BadgeData) =>
            (badge as BadgeData).badge?.type === EBadgeType.RIBBON,
        )?.badge as BadgeData;
        setRibbonBadge(foundRibbon?.ribbon);
      } else {
        foundRibbon = badges?.find(
          (badge: BadgeData) => badge.type === EBadgeType.RIBBON,
        );
        setRibbonBadge(foundRibbon?.ribbon);
      }
    }
  }, [badges]);

  return (
    <StyledBagelcodeBundle
      direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
      marginRight={
        price.spacing && price.symbolPosition === 'Left' ? '4px' : '0px'
      }
      marginLeft={
        price.spacing && price.symbolPosition === 'Right' ? '4px' : '0px'
      }
      productColor={
        productList.length > 0 ? productList[0].textFontColorHex : ''
      }
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      className="internal-bundle"
      isSale={!!salePercentage}
      borderRadius={borderRadius}
    >
      <Box className="container">
        <Box className="product">
          {productList.length > 0 && (
            <Box>
              <Box className="image-container">
                <img
                  alt="product"
                  className="image"
                  src={productList[0].images.product}
                />
              </Box>
              <Box className="amount" style={{ marginBottom: '-5px' }}>
                <Box>
                  {productList[0].images.productPrefix && (
                    <img src={productList[0].images.productPrefix} alt="coin" />
                  )}
                  {productList[0].quantityDisplay}
                </Box>
                {salePercentage > 0 &&
                  productList[0].type !== EProductType.TIME && (
                    <Box className="stroked">
                      {productList[0].strokedSaleQuantity}
                    </Box>
                  )}
              </Box>
            </Box>
          )}
          <Box
            className="price-container"
            style={{
              marginTop: productList.length > 0 ? 0 : 'auto',
            }}
          >
            <AutoTextSize
              mode="oneline"
              maxFontSizePx={16}
              minFontSizePx={4}
              flexGrow="1"
            >
              <BundlePrice
                price={price}
                type={EBundlesInternalViewModel.BAGLECODE}
              />
            </AutoTextSize>
          </Box>
        </Box>
        {ribbonBadge && (
          <>
            <RibbonBadge
              text={ribbonBadge.text}
              textColor={ribbonBadge.textColor}
              backgroundColor={ribbonBadge.backgroundColor}
              position={EBadgePosition.LEFT}
              viewModel={EBundlesInternalViewModel.BAGLECODE}
            ></RibbonBadge>
          </>
        )}
      </Box>
      {salePercentage > 0 && (
        <BagelcodeSaleBadge
          salePercentage={salePercentage}
          amountAfterSale={price.price}
          salePercentageDisplayType={salePercentageDisplayType}
        />
      )}
    </StyledBagelcodeBundle>
  );
};
